module.exports = __webpack_public_path__ + "media/site_templates/www.electriciannearme.agency/images/splash-1421d1fbf83e768ed8bbd7463094c368.jpg";